import { render } from "./Skin.vue?vue&type=template&id=649f7ab5"
import script from "./Skin.vue?vue&type=script&lang=js"
export * from "./Skin.vue?vue&type=script&lang=js"

import "./Skin.vue?vue&type=style&index=0&id=649f7ab5&lang=css"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__